import { LikelyToChurn, LikelyToMakeAPurchase, LikelyToSubscribe } from 'ui/illustrations';
import {
  StyledLikelyToChurn,
  StyledLikelyToPurchase,
  StyledLikelyToSubscribe,
} from 'modules/predictiveGoals/components/Styled';
import { TEST_IDS } from 'modules/predictiveGoals/constants';

export const LikelyToChurnIllustration = () => {
  return (
    <StyledLikelyToChurn data-test={TEST_IDS.LikelyToChurnIllustration}>
      <LikelyToChurn />
    </StyledLikelyToChurn>
  );
};

export const LikelyToPurchaseIllustration = () => {
  return (
    <StyledLikelyToPurchase data-test={TEST_IDS.LikelyToPurchaseIllustration}>
      <LikelyToMakeAPurchase />
    </StyledLikelyToPurchase>
  );
};

export const LikelyToSubscribeIllustration = () => {
  return (
    <StyledLikelyToSubscribe data-test={TEST_IDS.LikelyToSubscribeIllustration}>
      <LikelyToSubscribe />
    </StyledLikelyToSubscribe>
  );
};
